var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hedan-big-prize-wrapper"},[_c('div',{ref:"list",staticClass:"big-prize-list",class:{ 'active': _vm.addTransition }})])
}
var staticRenderFns = []

export { render, staticRenderFns }